import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9664ab8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "details-form__item" }
const _hoisted_6 = { class: "details-form__item" }
const _hoisted_7 = { class: "details-form__item" }
const _hoisted_8 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_location_and_workplace = _resolveComponent("location-and-workplace")!
  const _component_location_selection = _resolveComponent("location-selection")!
  const _component_language_selection = _resolveComponent("language-selection")!
  const _component_phone_selection = _resolveComponent("phone-selection")!
  const _component_step_actions = _resolveComponent("step-actions")!
  const _component_localisation_side = _resolveComponent("localisation-side")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "onClick:previous"]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isActivatedNewLocationAndWorkplace)
              ? (_openBlock(), _createBlock(_component_location_and_workplace, {
                  key: 0,
                  ref: "locationAndWorkplace",
                  onChange: _ctx.checkCountryValidity
                }, null, 8, ["onChange"]))
              : (_openBlock(), _createBlock(_component_location_selection, { key: 1 }))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_language_selection)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_phone_selection, {
              ref: "refPhoneSelection",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phone) = $event)),
              validation: _ctx.phoneValidation,
              "onUpdate:validation": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phoneValidation) = $event)),
              "display-error": _ctx.displayPhoneValidation && !_ctx.isPhoneValid
            }, null, 8, ["modelValue", "validation", "display-error"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "is-disabled-button-next": !_ctx.isCompletelyValid,
            "onClick:next": _ctx.goNext,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-next", "onClick:next", "onClick:previous"])
        ])
      ]),
      _createVNode(_component_localisation_side)
    ])
  ]))
}